import React from 'react'

import { buildings } from '../../core/controllers/Buildings'
import { buildingStatistics } from '../../helpers/Building/BuildingStatistics'

export default class SpacesStatCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            totalSpaces: 0,
            totalVacant: 0,
            totalLateRent: 0,
            totalOccupied: 0,
            totalMaintenance: 0
        };
    }

    componentDidMount() {
        var self = this;
        buildings.getAllBuildingStats(function(response) {
            buildingStatistics.determineStatistics(response.data, function() {
                self.setState({
                    totalSpaces: buildingStatistics.totalSpaces,
                    totalVacant: buildingStatistics.totalVacant,
                    totalLateRent: buildingStatistics.totalLateRent,
                    totalOccupied: buildingStatistics.totalOccupied,
                    totalMaintenance: buildingStatistics.totalMaintenance
                })
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        const totalSpaces = this.state.totalSpaces;
        const totalVacant = this.state.totalVacant;
        const totalLateRent = this.state.totalLateRent;
        const totalOccupied = this.state.totalOccupied;
        const totalMaintenance = this.state.totalMaintenance;
        return (
            <div class="row">
                <div class="col-md-3 col-sm-6 col-xs-12 custom-col-md-2">
                    <div class="info-box">
                        <span class="info-box-icon bg-light-blue"><i class="pe-7s-box2"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Total Spaces</span>
                            <span class="info-box-number">{ totalSpaces }<small></small></span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12 custom-col-md-2">
                    <div class="info-box">
                    <span class="info-box-icon bg-light-green"><i class="pe-7s-refresh-2"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Total Vacant</span>
                            <span class="info-box-number">{ totalVacant }<small></small></span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12 custom-col-md-2">
                    <div class="info-box">
                    <span class="info-box-icon bg-dark-blue"><i class="pe-7s-users"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Total Occupied</span>
                            <span class="info-box-number">{ totalOccupied }<small></small></span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12 custom-col-md-2">
                    <div class="info-box">
                    <span class="info-box-icon bg-dark-green"><i class="pe-7s-alarm"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Total Late on Rent</span>
                            <span class="info-box-number">{ totalLateRent }<small></small></span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12 custom-col-md-2">
                    <div class="info-box">
                    <span class="info-box-icon bg-light-blue"><i class="pe-7s-tools"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Total Work Orders</span>
                            <span class="info-box-number">{ totalMaintenance }<small></small></span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Spaces/SpacesStatCard.jsx